/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { User } from './User';
export type FinancierShopResponse = {
    id?: string;
    name?: string;
    ownerEmail?: string;
    shopReference?: string;
    status?: FinancierShopResponse.status;
    createdAt?: string;
    approvedAt?: string;
    ownerStatus?: FinancierShopResponse.ownerStatus;
    approvedBy?: User;
};
export namespace FinancierShopResponse {
    export enum status {
        ACTIVE = 'ACTIVE',
        WAITING_FOR_APPROVE = 'WAITING_FOR_APPROVE',
        EXPIRED = 'EXPIRED',
        SUSPENDED = 'SUSPENDED',
    }
    export enum ownerStatus {
        PENDING = 'PENDING',
        ACTIVE = 'ACTIVE',
        SUSPENDED = 'SUSPENDED',
    }
}

